var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vendor-contact-name" },
    [
      _vm.allowAccessContact
        ? _c("router-link", { attrs: { to: _vm.toRoute } }, [
            _vm._v("\n    " + _vm._s(_vm.displayName) + "\n  "),
          ])
        : _c("span", [_vm._v(_vm._s(_vm.displayName))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }